<template>
  <router-view />
</template>

<script setup>
import { onMounted } from "vue";
onMounted(() => {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    // 移动端适用于750的设计稿
    var iScale = 1
    iScale = iScale / window.devicePixelRatio
    document.write(
      '<meta name="viewport" content="width=device-width,' +
      'initial-scale=' +
      iScale +
      ',minimum-scale=' +
      iScale +
      ',maximum-scale=' +
      iScale +
      ',user-scalable=no" />'
    )
    var iWidth = document.documentElement.clientWidth
    document.getElementsByTagName('html')[0].style.fontSize =
      (iWidth / 75) * 2 + 'px'
  }
})
</script>

<style lang="scss">
html,
body {
  height: 100%;
  font-family: "微软雅黑";
  background: #f9f9f9 !important;
}
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
#navbar {
  width: 100%;
}
.van-tabbar {
  z-index: 999 !important;
}
.van-nav-bar {
  z-index: 9999999 !important;
  height: 4.4rem !important;
}
.van-field__label {
  width: 9.8rem !important;
}
.van-nav-bar__title {
  color: #444 !important;
  font-family: "华文细黑";
}
// .van-nav-bar__content {
//   background-image: linear-gradient(
//     rgb(184 208 228),
//     rgb(116, 176, 255)
//   ) !important;
// }
.van-nav-bar .van-icon {
  color: #444 !important;
}
.van-cell-group--inset {
  margin: 0rem !important;
}
.van-field__control,
.van-radio__label {
  color: #999 !important;
}
/* 适配iphoneX iphoneXS */
@media screen and (device-width: 375px) and (device-height: 812px) {
}
/* 适配iphoneXR iphoneXSMax */
@media screen and (device-width: 414px) and (device-height: 896px) {
}
/* 适配iphonePro */
@media screen and (device-width: 390px) and (device-height: 844px) {
}
</style>